// extracted by mini-css-extract-plugin
export default {"wrapper":"YMapPage_wrapper__TjTq5"};